import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { PackageProvider } from './context/ProjectContext';

import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";

import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Destinations from './components/Destinations';
import Varkala from './components/Varkala';
import Kovalam from './components/Kovalam';
import Munnar from './components/Munnar';
import Kanyakumari from './components/Kanyakumari';
import Alappuzha from './components/Alappuzha';
import Jatayu from './components/Jatayu';
import Kumarakom from './components/Kumarakom';
import Thekkady from './components/Thekkady';
import Rameshwaram from './components/Rameshwaram';
import Madurai from './components/Madurai';
import Wayanad from './components/Wayanad';
import Cochin from './components/Cochin';
import Guruvayur from './components/Guruvayur';

import Contact from './components/Contact';
import Package1 from './components/Package1';
import Package2 from './components/Package2';
import Package3 from './components/Package3';
import Packages from './components/Packages';
import AddPackage from './components/AddPackage';  // Add this import
import KeralaResponsibleTourism from './components/ResponsibleTourism';
import ScrollToTop from './components/shared/ScrollToTop';
import './App.css';

class App extends Component {
  render() {
    return (
      <PackageProvider>  {/* Wrap everything with PackageProvider */}
        <Router>
          <ScrollToTop />
          <Header />
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/package1" element={<Package1 />} />
            <Route path="/package2" element={<Package2 />} />
            <Route path="/package3" element={<Package3 />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/add-package" element={<AddPackage />} />  {/* Add this route */}

            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/varkala" element={<Varkala />} />
            <Route path="/kovalam" element={<Kovalam />} />
            <Route path="/munnar" element={<Munnar />} />
            <Route path="/kanyakumari" element={<Kanyakumari />} />
            <Route path="/alappuzha" element={<Alappuzha />} />
            <Route path="/jatayu" element={<Jatayu />} />
            <Route path="/kumarakom" element={<Kumarakom />} />
            <Route path="/thekkady" element={<Thekkady />} />
            <Route path="/rameshwaram" element={<Rameshwaram />} />
            <Route path="/madurai" element={<Madurai />} />
            <Route path="/wayanad" element={<Wayanad />} />
            <Route path="/cochin" element={<Cochin />} />
            <Route path="/guruvayur" element={<Guruvayur />} />
            <Route path="/responsible-tourism" element={<KeralaResponsibleTourism />} />
          </Routes>
          
          <Footer />
        </Router>
      </PackageProvider>
    );
  }
}

export default App;